import { SelectiveExceptionHandler } from './selective-exception-handler'
import { AppMetricsService } from '../../core/services'

// Raven (Sentry client)
// https://docs.getsentry.com/hosted/clients/javascript/integrations/@angular/
import * as Raven from 'raven-js'

// TODO [GitHub Issue]: We might want to move this later to some other place,
// where we have access to additional information such as the app context/user info etc.
export class SentryExceptionHandler extends SelectiveExceptionHandler {

  private _info: { [key: string]: any } = {}
  private _appMetricsService: AppMetricsService

  public set appMetricsService(appMetricsService) {
    this._appMetricsService = appMetricsService
  }

  constructor(ravenConfigs) {
    super()
    // TODO [GitHub Issue]: Use further configuration options if necessary: https://webpack.github.io/docs/configuration.html
    Raven.config(
      ravenConfigs.endpoint,
      {
        release: ravenConfigs.releaseVersionId.toString(),
        environment: ravenConfigs.environment.toString()
      }
    )
  }

  public addInfo(key: string, value: any) {
    this._info[key] = value
    Raven.setUserContext(this._info)
  }

  public handleError(exception: any, _stackTrace?: any, _reason?: string) {
    const metric = this._appMetricsService || { toJson: () => '{}' }
    Raven.setExtraContext(metric.toJson())
    Raven.captureException(exception)
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/helpers/exception-handlers/sentry-exception-handler.ts